
import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'

export default Vue.extend({
  data: () => ({
    counties: [
      'Baranya',
      'Bács-Kiskun',
      'Békés',
      'Borsod-Abaúj-Zemplén',
      'Csongrád-Csanád',
      'Fejér',
      'Győr-Moson-Sopron',
      'Hajdú-Bihar',
      'Heves',
      'Jász-Nagykun-Szolnok',
      'Komárom-Esztergom',
      'Nógrád',
      'Pest',
      'Somogy',
      'Szabolcs-Szatmár-Bereg',
      'Tolna',
      'Vas',
      'Veszprém',
      'Zala'
    ]
  }),

  computed: {
    ...mapFields({
      name: 'requester.name',
      county: 'requester.county',
      city: 'requester.city',
      address: 'requester.address',
      email: 'requester.email',
      phone: 'requester.phone',
      rules: 'requester.rules',
      requesterForm: 'formValidity.requesterForm'
    })
  },

  methods: {
    submit () {
      if ((this as any).$refs.form.validate()) {//eslint-disable-line
        this.$emit('moveToNext')
      }
    }
  }
})
